import React from 'react'

function HTFooter () {
  return (
    <footer>
      
    </footer>
  )
}

export default HTFooter



// WEBPACK FOOTER //
// src/components/HTFooter.js